// On-page notices and confirmations — never browser pop-ups. Browser pop-ups
// (alert / confirm / prompt) freeze the page until someone clicks OK, which also
// stops anything working the portal for you (like Claude in Chrome).
//   showNotice(text)        → a message at the top of the screen; closes itself
//   askConfirm(text, ok)    → Promise<boolean>, on-page Yes / Cancel buttons
//   askText(text)           → Promise<string|null>, on-page text box + OK / Cancel
import { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";

let push = null;
const waiting = [];
function ensureHost() {
  if (push || typeof document === "undefined") return;
  if (document.getElementById("cps-dialog-host")) return;
  const el = document.createElement("div");
  el.id = "cps-dialog-host";
  document.body.appendChild(el);
  createRoot(el).render(<DialogHost />);
}
function send(item) {
  ensureHost();
  if (push) push(item); else waiting.push(item);
}
export function showNotice(text) { send({ kind: "notice", text: String(text == null ? "" : text) }); }
export function askConfirm(text, okLabel) {
  return new Promise((res) => send({ kind: "confirm", text: String(text), okLabel: okLabel || "Yes", res }));
}
export function askText(text) {
  return new Promise((res) => send({ kind: "text", text: String(text), res }));
}

let seq = 0;
function DialogHost() {
  const [items, setItems] = useState([]);
  const [value, setValue] = useState("");
  useEffect(() => {
    push = (item) => setItems((xs) => [...xs, { ...item, id: ++seq }]);
    while (waiting.length) push(waiting.shift());
    return () => { push = null; };
  }, []);
  const notices = items.filter((x) => x.kind === "notice");
  const ask = items.find((x) => x.kind !== "notice");
  const close = (id) => setItems((xs) => xs.filter((x) => x.id !== id));
  useEffect(() => {
    if (!notices.length) return;
    const t = setTimeout(() => close(notices[0].id), 9000);
    return () => clearTimeout(t);
  }, [notices.length ? notices[0].id : 0]);
  const answer = (v) => { ask.res(v); setValue(""); close(ask.id); };
  return (
    <>
      <div style={{ position: "fixed", top: 12, left: "50%", transform: "translateX(-50%)", zIndex: 10000, width: "min(560px, calc(100% - 32px))", display: "flex", flexDirection: "column", gap: 8 }}>
        {notices.map((n) => (
          <div key={n.id} role="status" data-testid="page-notice" style={{ background: "#1F2937", color: "#fff", borderRadius: 8, padding: "10px 14px", fontSize: 14, display: "flex", gap: 12, alignItems: "flex-start", boxShadow: "0 4px 14px rgba(0,0,0,.25)", whiteSpace: "pre-wrap" }}>
            <span style={{ flex: 1 }}>{n.text}</span>
            <button type="button" aria-label="Close" onClick={() => close(n.id)} style={{ background: "none", border: 0, color: "#fff", fontSize: 18, cursor: "pointer", lineHeight: 1 }}>×</button>
          </div>
        ))}
      </div>
      {ask && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.35)", zIndex: 10001, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div role="dialog" data-testid="page-confirm" style={{ background: "#fff", borderRadius: 10, padding: 18, width: "min(460px, 100%)", fontSize: 14, whiteSpace: "pre-wrap", boxShadow: "0 8px 30px rgba(0,0,0,.3)" }}>
            <div style={{ marginBottom: 12 }}>{ask.text}</div>
            {ask.kind === "text" && (
              <input autoFocus data-testid="page-confirm-input" value={value} onChange={(e) => setValue(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter" && value.trim()) answer(value); }} style={{ width: "100%", marginBottom: 12 }} />
            )}
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <button type="button" className="btn-secondary" data-testid="page-confirm-cancel" onClick={() => answer(ask.kind === "text" ? null : false)}>Cancel</button>
              <button type="button" className="btn-primary" data-testid="page-confirm-ok"
                disabled={ask.kind === "text" && !value.trim()}
                onClick={() => answer(ask.kind === "text" ? value : true)}>{ask.kind === "text" ? "OK" : ask.okLabel}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
